export const IMPORT_TEMPLATE_URL = '/template-lista-de-gaps.xlsx';
export const IMPORT_TEMPLATE_FILENAME = 'Template Lista de Gaps.xlsx';
